(function($) {
  "use strict";

  jQuery(document).ready(function(){



    /* Match Heigh   
        $('.item').matchHeight(); 
  */

    
    $(".do-nicescrol").niceScroll();
    
    
    

  });
  
})(jQuery);
